<template lang="pug">
  .white-fone
    .img-wrap
      .img(v-if="(data.image_urls || {}).mid" :style="{ 'background-image': 'url(' + (data.image_urls || {}).mid + ')'}")
      .img(v-else)

    .field.input-field
      input(
      :id="`publish_${data.id}`"
      type="checkbox"
      name="publish"
      class="switch is-outlined is-success"
      v-model="data.is_active"
      @click="activate()"
      )
      label(:for="`publish_${data.id}`")
        span  {{ data.is_active ? gettext('Published') : gettext('Not published') }}

    p.type {{ data.first_name }} {{ data.last_name | sliceName }}
    p.cv-type(v-if="seasonal") {{ gettext('For seasonal work') }}
    p.profession(v-if="data.has_profession && data.type === CONSTANTS.TYPE_PERMANENT_WORK")
      | {{ `${(data.profession_company_type || {}).name} / ${(data.profession_company_sector || {}).name} / ${(data.profession || {}).name}` }}
    p.profession(v-else-if="data.has_profession && data.type === CONSTANTS.TYPE_SEASONAL_WORK")
      | {{ `${data.profession_company_type.name}` }}
    p.posted {{ `${gettext('Posted')}:` }} {{ data.created_dt | dateNormalize }}

    .btn-get
      router-link(:to="{name: 'EditCV', params: {lang: getLanguage, id: data.id}}").mdi.mdi-circle-edit-outline.icon-edit
      router-link(v-if="data.is_active" :to="{name: 'ViewCV', params: {lang: getLanguage, id: data.id, prev: $route.query.page}}").mdi.mdi-eye.icon-look
      .delete-cv: span.mdi.mdi-delete-circle.icon-delete(@click="remove")
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { gettext, ngettext } from '@/services/TranslateHandler'
import swal from 'sweetalert2'
const CONSTANTS = require('@/constants.json')
const moment = require('moment')
const toastr = require('toastr')

export default {
  name: 'CVPreview',
  data () {
    return {
      CONSTANTS: CONSTANTS
    }
  },
  props: {
    data: {
      default: () => {
        return {}
      }
    },
    seasonal: {
      default: false
    }
  },
  filters: {
    sliceName: function (name) {
      return `${name.charAt(0)}. `
    },
    dateNormalize: function (date) {
      return moment(date).format('DD.MM.YYYY')
    }
  },
  methods: {
    gettext: gettext,
    ngettext: ngettext,
    ...mapActions([
      'getCountry',
      'jobseekerActivateCV',
      'jobseekerDeleteCV'
    ]),
    activate () {
      this.$nextTick(() => {
        this.jobseekerActivateCV({id: this.data.id, active: this.data.is_active}).then(() => {
          toastr.success(gettext('Status changed'), gettext('Success!'))
        }).catch(() => {
          toastr.error(gettext('Status not changed'), gettext('Error!'))
        })
      })
    },
    remove () {
      swal({
        title: gettext('Are you sure?'),
        text: gettext('You won\'t be able to revert this!'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: gettext('Yes, delete it!')
      }).then((result) => {
        if (result.value) {
          this.jobseekerDeleteCV(this.data.id).then(() => {
            this.$emit('delete')
            toastr.success(gettext('CV deleted'), gettext('Success!'))
          }).catch(() => {
            toastr.error(gettext('Server error'), gettext('Error!'))
          })
        }
      })
    }
  },
  computed: {
    ...mapGetters([
      'getLanguage'
    ])
  }
}
</script>

<style lang='scss' scoped>
  .work-types {
    margin-bottom: 10px;
    span {
      &.tag {
        &.is-success {
          &.looking {
            margin-left: 1px;
          }
        }
      }
    }
  }
  .white-fone{
    position: relative;
    box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.2);
    padding: 1.5rem 1.5rem 3.5rem 1.5rem;
  }

  .input-field {
    min-height: 50px;
    display: inline-block;
    margin: 0 0 1rem 0 !important;
    span {
      position: absolute;
      top: 30px;
      left: 0;
      white-space: nowrap;
    }
  }
  .img-wrap {
    float: right;
    position: relative;
    display: inline-block;
    width: 85px;
    height: 85px;
    border-radius: 50%;
    overflow: hidden;
    .img {
      background-image: url("/assets/images/workers/worker-default.png");
      background-size: contain;
      background-repeat: no-repeat;
      display: inline-block;
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
    }
  }
  .btn-get {
    display: flex;
    width: 100%;
    justify-content: space-around;
    position: absolute;
    top: auto;
    bottom: 0;
    left: 0;
    width: 100%;
    color: #000;
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: 0.14px;
    padding: 10px 0;
    min-height: 50px;
    border-top: 1px solid #c7c7c7;
  }
  h3{
    font-size: 18px;
    font-weight: 300;
  }
  p{
    &.type{
      font-weight: 400;
    }
    &.title{
      line-height: 24px;
      font-weight: bold;
      margin: 1rem 0;
    }
  }
   .field{
     margin-top: 1rem;
     margin-bottom: .5rem;
     label{
       font-size: 14px;
     }
   }
</style>



// WEBPACK FOOTER //
// src/pages/profile/cvs/parts/cv-preview/index.vue